"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LedgerReport = void 0;
require("./ledgerReport.less");
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community/dist/styles/ag-theme-balham.css");
const React = require("react");
const no_data_found_1 = require("../no-data-found/no-data-found");
const ag_grid_react_1 = require("ag-grid-react");
const ledgerHeader_1 = require("../ledgerHeader");
const number_formatter_1 = require("./number-formatter");
const alert_1 = require("client/components/ui/alert");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/ledger/store");
const mobx_react_1 = require("mobx-react");
// Need to pass the data into the component via props so that I can use the constructor function properly
// and not have to wait for the data to load because it is already being passed in.
let LedgerReport = class LedgerReport extends React.Component {
    constructor(props) {
        super(props);
        this.id = "hot-ledger";
        this.onButtonExport = () => {
            const params = {
                fileName: "Ledger.csv"
            };
            this.storeData.gridApi.exportDataAsCsv(params);
        };
        this.storeData = {
            columnDefs: [
                {
                    enableRowGroup: true,
                    field: "Pharmacy",
                    filter: "agTextColumnFilter",
                    headerName: "Pharmacy"
                },
                {
                    enableRowGroup: true,
                    field: "Source",
                    filter: "agTextColumnFilter",
                    headerName: "Source",
                    width: 180
                },
                {
                    field: "Reference #",
                    filter: "agTextColumnFilter",
                    headerName: "Reference #",
                    width: 120
                },
                {
                    field: "Reference Type",
                    headerName: "Reference Type",
                    width: 150,
                    valueGetter: (params) => {
                        let newReferenceType = params.data["Reference Type"] == "RXNumber" ? "RxNumber" : "";
                        return newReferenceType;
                    } // D-002.834
                },
                {
                    field: "Vendor",
                    filter: "agTextColumnFilter",
                    headerName: "Vendor"
                },
                {
                    field: "Date",
                    filter: "agDateColumnFilter",
                    headerName: "Date",
                    width: 180,
                    filterParams: {
                        comparator: (filterLocalDateAtMidnight, cellValue) => {
                            if (!cellValue)
                                return -1;
                            const dateParts = cellValue.split("/");
                            if (dateParts.length !== 3)
                                return -1;
                            const cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
                            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                                return 0;
                            }
                            return cellDate < filterLocalDateAtMidnight ? -1 : 1;
                        },
                        browserDatePicker: true
                    },
                    comparator: (date1Str, date2Str) => {
                        if (!date1Str)
                            return -1;
                        if (!date2Str)
                            return 1;
                        const dateParts1 = date1Str.split("/");
                        const dateParts2 = date2Str.split("/");
                        const date1 = new Date(Number(dateParts1[2]), Number(dateParts1[0]) - 1, Number(dateParts1[1]));
                        const date2 = new Date(Number(dateParts2[2]), Number(dateParts2[0]) - 1, Number(dateParts2[1]));
                        return date1.getTime() - date2.getTime();
                        // D-032.12 e
                    }
                },
                {
                    cellRenderer: "numberFormatter",
                    field: "Credit",
                    filter: "agNumberColumnFilter",
                    headerName: "Credit",
                    type: "numericColumn",
                    width: 100
                },
                {
                    cellRenderer: "numberFormatter",
                    field: "Debit",
                    filter: "agNumberColumnFilter",
                    headerName: "Debit",
                    type: "numericColumn",
                    width: 100
                },
                {
                    cellRenderer: "numberFormatter",
                    field: "Balance",
                    filter: "agNumberColumnFilter",
                    headerName: "Balance",
                    type: "numericColumn",
                    width: 120
                },
                {
                    field: "Notes",
                    filter: "agTextColumnFilter",
                    headerName: "Notes"
                },
                {
                    field: "Portal User",
                    filter: "agTextColumnFilter",
                    headerName: "Portal User"
                }
            ],
            // anything specified in defaultColDef gets applied on all columns
            defaultColDef: {
                enablePivot: true,
                enableRowGroup: true,
                enableValue: true,
                filter: true,
                resizable: true,
                sortable: true,
                comparator(a, b) {
                    if (typeof a === "string") {
                        return a.localeCompare(b);
                    }
                    return a > b ? 1 : a < b ? -1 : 0;
                }
            },
            floatingFilter: true,
            frameworkComponents: {
                numberFormatter: number_formatter_1.NumberFormatter
            },
            multiSortKey: "ctrl",
            rowData: []
        };
    }
    async componentDidMount() {
        store_1.ledgerStore.showLoader = true;
        await this.recursiveFunc();
    }
    componentWillUnmount() {
        store_1.ledgerStore.ledgerData.value = [];
        store_1.ledgerStore.columnHeaders = null;
    }
    async recursiveFunc() {
        const funcDone = await store_1.ledgerStore.loadLedger();
        let timer;
        if (!funcDone) {
            timer = setTimeout(() => {
                this.recursiveFunc();
            }, 10000);
        }
        if (funcDone) {
            clearTimeout(timer);
        }
        return funcDone;
    }
    render() {
        const storeData = store_1.ledgerStore.ledgerData
            ? store_1.ledgerStore.ledgerData.value
            : [];
        this.storeData.rowData = storeData;
        const loadingData = store_1.ledgerStore.showLoader;
        if (storeData && storeData.length > 0) {
            return (React.createElement(React.Fragment, null,
                React.createElement(ledgerHeader_1.LedgerHeader, { title: "Ledger", withDatePicker: true }),
                React.createElement("div", { className: "ag-theme-balham", style: {
                        height: "85%",
                        width: "100%"
                    } },
                    React.createElement("button", { type: "button", onClick: this.onButtonExport.bind(this) }, "Export to CSV"),
                    React.createElement(ag_grid_react_1.AgGridReact, { onGridReady: params => {
                            this.storeData.gridApi = params.api;
                        }, columnDefs: this.storeData.columnDefs, defaultColDef: this.storeData.defaultColDef, 
                        /* this is where we provide custom components */
                        frameworkComponents: this.storeData.frameworkComponents, 
                        /* this is where we enable multiple column sorting with 'ctrl' key/ 'Cmd' key on apple (default was the 'shift' key) */
                        multiSortKey: this.storeData.multiSortKey, 
                        /* this is where we provide animation while sorting */
                        animateRows: true, 
                        /* this is where we enable the sidebar with pivoting and filtering */
                        sideBar: true, groupMultiAutoColumn: true, floatingFilter: this.storeData.floatingFilter, 
                        /* disable Excel export until we are able to handle export in the back end - only CSV export available for now */
                        suppressExcelExport: true, rowData: this.storeData.rowData }))));
        }
        if (storeData) {
            if (loadingData) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(ledgerHeader_1.LedgerHeader, { title: "Ledger", withDatePicker: true }),
                    React.createElement("div", null, "Loading Data...")));
            }
            // Return a Custom built component here to handle 0 data returned.
            return (React.createElement(no_data_found_1.default, { headerComponent: React.createElement(ledgerHeader_1.LedgerHeader, { title: "Ledger", withDatePicker: true }) }));
        }
        if (store_1.ledgerStore.ledgerData.error) {
            return React.createElement(alert_1.UiAlert, { message: "Error in loading ledger" });
        }
        return React.createElement(ui_1.UiLoadingIndicator, null);
    }
};
LedgerReport = __decorate([
    mobx_react_1.observer
], LedgerReport);
exports.LedgerReport = LedgerReport;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/ledger/modules/ledger-list/components/ledgerReport/ledgerReport.tsx
// module id = 3712
// module chunks = 0